const loader = document.querySelector('#loader');

window.addEventListener('load', () => {
    if(loader)
        loader.style.display= 'none';
});